<script>
import { mapState } from 'vuex';
import SearchResultsTabStores from '@phoenix/mixins/components/search/SearchResultsTabStores';
import SearchResultsTab from '../search/SearchResultsTab';
import StoreCard from '@maison/components/store/StoreCard';
import { IndexNames } from '@module/Algolia/resources/js/search/AlgoliaSearch';
import { algoliaTracking } from '@module/Algolia/resources/js/insights/helpers';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

export default {
  components: {
    SearchResultsTab,
    StoreCard,
    PhxsgButton,
  },

  mixins: [SearchResultsTabStores],

  computed: {
    ...mapState('search', ['query']),

    storeSearchUrl() {
      return window.route('boutiques');
    },
  },

  methods: {
    onStoreClick(store, position) {
      algoliaTracking(store, position, IndexNames.Stores);
    },
  },
};
</script>

<template>
  <search-results-tab :tab="tab" :limit="limit" has-paging-label>
    <ul class="grid gap-base lg:grid-cols-3">
      <template v-if="hasBoutiques">
        <li v-for="(store, index) in boutiques" :key="store.id" role="presentation">
          <store-card
            :address="store.fullAddress"
            :image="store.rokkaImg"
            :title="store.name"
            :status="getStatus(store)"
            :phone="store.phone"
            :permalink="store.permalink"
            :product-categories="store.productCategories"
            :is-online="store.isOnline"
            :see-more-label="store.seeMoreLabel"
            :data-tracking="dataTracking"
            background-color="var(--color-grey-100)"
            @click="onStoreClick(store, index, indexName)"
          />
        </li>
      </template>

      <template v-if="hasRetailers">
        <li v-for="(store, index) in retailers" :key="store.id" role="presentation">
          <store-card
            :address="store.fullAddress"
            :image="store.rokkaImg"
            :title="store.name"
            :status="getStatus(store)"
            :phone="store.phone"
            :permalink="store.permalink"
            :product-categories="store.productCategories"
            :is-online="store.isOnline"
            :see-more-label="store.seeMoreLabel"
            :data-tracking="dataTracking"
            background-color="var(--color-grey-100)"
            @click="onStoreClick(store, index, indexName)"
          />
        </li>
      </template>
    </ul>

    <template #noResultAction>
      <PhxsgButton v-if="storeSearchUrl" use="a" :href="storeSearchUrl" variant="plain" color="primary">
        {{ $t('SearchPanel.stores.noResult.action.label') }}
      </PhxsgButton>
    </template>
  </search-results-tab>
</template>
